import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InfoPopoverButton from "../../InfoPopoverButton";

const CardInfo = ({ color, description, hint, icon, infoId, title, value }) => (
  <div className="col-xl-3 col-md-6 mb-4">
    <div className={`card border-left-${color} shadow h-100 py-2`}>
      <div className="card-body">
        <div className="row no-gutters align-items-center">
          <div className="col mr-2">
            <div
              className={`text-xs font-weight-bold text-${color} text-uppercase mb-1 d-flex align-items-center`}
            >
              <span>{title}</span>
              <InfoPopoverButton
                id={infoId}
                title={title}
                description={description}
              />
            </div>
            <div className="h5 mb-0 font-weight-bold text-gray-800">
              {value}
            </div>
          </div>
          <div className="col-auto">
            <FontAwesomeIcon className="fa-2x text-gray-300" icon={icon} />
          </div>
        </div>
        <small>{hint}</small>
      </div>
    </div>
  </div>
);

export default CardInfo;
